export default __webpack_public_path__ + "static/placeholder-style0-4-3-bae9d601a1c6605da27ae8631e36ec9a.png";